var intlTelInput = require('intl-tel-input');

/**
 * Form Field Phone
 * @param  {[type]} options [description]
 * @return {[type]}         [description]
 */
var FormFieldPhone = function(options){

  var self = this;

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

  // our international phone number field variables
  this.$input = this.options.$el.find("input[type='tel']");
  this.input = this.$input[0];
  this.$countryDropdown = this.options.$el.find('.input select');
  this.errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];

  // initialize international phone number field
  this.iti = intlTelInput(this.input, {
    utilsScript: '/built/intl-tel-input-utils.js'
  });

  // country changed, update dropdown that submits to sprout
  this.input.addEventListener("countrychange", function() {

    var countryCode = self.iti.getSelectedCountryData().iso2.toUpperCase();

    if (self.$countryDropdown.length)
    {
      self.$countryDropdown.val(countryCode);
    }

  });

  // on load, set the country to match the one in the dropdown
  var selectedCountry = this.$countryDropdown.val().toLowerCase();
  var iti = window.intlTelInputGlobals.getInstance(self.input);
  this.iti.setCountry(selectedCountry);

};

/**
 * Init
 * @return {[type]} [description]
 */
FormFieldPhone.prototype.init = function(){

  var self = this;

  this.$input.on("focus", function(){
    self.options.$el.addClass("is-focused");
  });

  this.$input.on("blur", function(){
    if(! self.checkValue()){
      self.options.$el.removeClass("is-focused");
    }
  });

  if(self.checkValue()){
    self.options.$el.addClass("is-focused");
  }

};

/**
 * Does the form field have value
 * @return {[type]} [description]
 */
FormFieldPhone.prototype.checkValue = function(){

  return this.$input.val().length > 1 ? true : false;

};

export default  FormFieldPhone;
